import * as React from "react";

export default function ListComponent(props) {

    return (
        
        <div>
            <ol>
                {props.items}
            </ol>
        </div>

    );
}
